"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
var Eliminations_1 = require("./Eliminations");
var SequentialGame = /** @class */ (function () {
    function SequentialGame(game) {
        this.state = game;
    }
    SequentialGame.prototype.isLegalMove = function (playerId, move) {
        if (!this.getLegalMoves || !this.getActivePlayer) {
            throw new Error('You must either implement "isLegalMove" or ("getLegalMoves" and "getActivePlayer")');
        }
        if (playerId !== this.getActivePlayer()) {
            return false;
        }
        if (this.getLegalMoves().some(function (legalMove) { return (0, fast_deep_equal_1.default)(move, legalMove); })) {
            return true;
        }
        if ((0, Eliminations_1.hasEliminations)(this) && this.giveUpMove) {
            return (0, fast_deep_equal_1.default)(move, this.giveUpMove(playerId));
        }
        return false;
    };
    SequentialGame.prototype.isTurnToPlay = function (playerId) {
        if (!this.getActivePlayer) {
            throw new Error('You must either implement "isTurnToPlay" or "getActivePlayer"');
        }
        return playerId === this.getActivePlayer();
    };
    SequentialGame.prototype.isOver = function () {
        if (!this.getActivePlayer) {
            throw new Error('You must either implement "isOver" or "getActivePlayer"');
        }
        return this.getActivePlayer() === undefined;
    };
    return SequentialGame;
}());
exports.default = SequentialGame;
